import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UnitType } from '../../../../../models/enums/unit-type.enum';
import { MeasurementService } from '../../../../../services/measurement.service';

@Component({
    selector: 'app-nearest-obstruction',
    templateUrl: './nearest-obstruction.component.html',
    styleUrls: ['./nearest-obstruction.component.scss'],
})
export class NearestObstructionComponent implements OnInit {
    @Input() cssClass;
    @Input() form: UntypedFormGroup;

    tooltip_position = 'above';

    constructor(private measSvc: MeasurementService) {}

    ngOnInit(): void {
        this.form
            .get('nearestObstruction')
            .valueChanges.subscribe((value) =>
                this.form.get('nearestObstruction').patchValue(this.measSvc.format(value, UnitType.DefaultLengthUnit), { emitEvent: false })
            );
    }

    onBlurEvent(event: any) {
        let resp = event.target.value.split(' ');
        let val = resp[0];
        let unitExt;
        let newVal = 0;
        if (val != '') {
            if (resp[0] < 0) {
                newVal = resp[0] * -1;
                unitExt = this.checkAndSetUnit(resp[1]);
                this.form.get('nearestObstruction').setValue(newVal.toString() + unitExt);
            }

            if (val > 9999 || newVal > 9999) {
                unitExt = this.checkAndSetUnit(resp[1]);
                this.form.get('nearestObstruction').setValue(parseFloat('9999').toString() + unitExt);
            }
        }
    }

    checkAndSetUnit(val) {
        let unitExt;
        if (val.toLowerCase().indexOf('in') != -1 || val.indexOf('"') != -1) {
            return (unitExt = '"');
        } else if (val.toLowerCase().indexOf('m') != -1) {
            return (unitExt = 'mm');
        }
    }
}
